<script lang="ts" setup>
definePageMeta({
	title: "Home",
});
</script>

<template>
	<h1 class="sr-only">VICAV - Vienna Corpus of Arabic Varieties</h1>
</template>
